<content class="image-color-content" [formGroup]="form">
  <h5><span>{{ 'global.denominacion' | translate }} </span>{{ desDenominacion }}</h5>
  <div class="image-dropzone"
       [ngClass]="{'dragging': isDragging}"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)"
       (click)="fileInput.click()">

    <ng-container *ngIf="!selected64Image">
      <div class="image-dropzone-icon">
        <i class="fas fa-plus"></i>
      </div>
      <span class="image-dropzone-title">{{'titles.anyadirImagen' | translate}}</span>
      <span class="image-dropzone-subtitle">{{'titles.arrastraClic' | translate}}</span>
    </ng-container>

    <ng-container *ngIf="selected64Image">
      <img [src]="selected64Image" class="image-preview" alt="Preview" draggable="false">
      <p>{{ selectedFile?.name || currentFile?.name }}</p>
    </ng-container>
    
    <input #fileInput type="file" accept=".jpg,.jpeg,.png" (change)="onFileSelected($event)" hidden>
  </div>

  <div class="color-row">
    <span>{{'titles.colorAsociado' | translate}}</span>
    <div class="color-row-right">
      <div class="label-color">
        <input type="color" formControlName="color">
      </div>
      <span class="color-hex">{{colorDisplay | uppercase}}</span>
    </div>
  </div>
</content>

<footer class="button-bar-center">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{'global.confirmar' | translate}}</button>
</footer>

<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
